$(function(){
  if (window.__relatedProductsHasFired) {
    return;
  }

  window.Branch = window.Branch || {};
  window.Branch.relatedProducts = window.Branch.relatedProducts || {};
  window.Branch.relatedProducts.sliders = window.Branch.relatedProducts.sliders || {};
  window.__relatedProductsHasFired = true;

  const initRelatedProductsSlider = function(relatedProductsSection, parent){
    let styling = relatedProductsSection.getAttribute('data-styling');
    let parentId = parent.getAttribute('id');
    let params;
    if(styling == 'homepage'){
      params = {
        slidesPerView: 1.25,
        spaceBetween: 30,
        navigation: {
            nextEl: `#${parentId} .related-products.page-container .swiper-button-next`,
            prevEl: `#${parentId} .related-products.page-container .swiper-button-prev`,
        },
        breakpoints: {
            600: {
              slidesPerView: 2.25,
              spaceBetween: 40,
              navigation: {
                nextEl: `#${parentId} .related-products.page-container .swiper-button-next`,
                prevEl: `#${parentId} .related-products.page-container .swiper-button-prev`,
              }
            },
            1024: {
              slidesPerView: 3.25,
              spaceBetween: 40,
              navigation: {
                nextEl: `#${parentId} .related-products.page-container .swiper-button-next`,
                prevEl: `#${parentId} .related-products.page-container .swiper-button-prev`,
              }
            }
          },
          on: {
            init: window.Branch.functions.checkSwiperNavVisibility,
            resize: window.Branch.functions.checkSwiperNavVisibility,
          }
      }
    } else {
      params = {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: `#${parentId} .related-products.page-container .swiper-button-next`,
            prevEl: `#${parentId} .related-products.page-container .swiper-button-prev`,
        },
        breakpoints: {
            600: {
              slidesPerView: 2,
              spaceBetween: 20,
              navigation: {
                nextEl: `#${parentId} .related-products.page-container .swiper-button-next`,
                prevEl: `#${parentId} .related-products.page-container .swiper-button-prev`,
              }
            },
            840: {
              slidesPerView: 3,
              spaceBetween: 20,
              navigation: {
                nextEl: `#${parentId} .related-products.page-container .swiper-button-next`,
                prevEl: `#${parentId} .related-products.page-container .swiper-button-prev`,
              }
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
              navigation: {
                nextEl: `#${parentId} .related-products.page-container .swiper-button-next`,
                prevEl: `#${parentId} .related-products.page-container .swiper-button-prev`,
              }
            }
          }
          
      }
    }
    
    
    window.Branch.relatedProducts.sliders[`${parentId}`] = new Swiper(`#${parentId} .related-products.page-container .related-products__product-carousel-container`, params);
    };

    const updateImageSrcSet = function(cloneDiv, cookieDescriptionStringArray, styling){
      let baseUrl = `//www.branchfurniture.com/cdn/shop/`;
      if(window.location.href.indexOf("branchfurniture.ca") > -1){baseUrl = `//www.branchfurniture.ca/cdn/shop/`}
      let cookieProductImageUrl =  `${baseUrl}${cookieDescriptionStringArray[1].trim()}`;
      let cookieProductHoverImageUrl = `${baseUrl}${cookieDescriptionStringArray[1].trim()}`;
      let srcSet = window.Branch.functions.returnSrcSet(cookieProductImageUrl);
      let hoverSrcSet = window.Branch.functions.returnSrcSet(cookieProductImageUrl);

        if(cookieDescriptionStringArray[8]){
          cookieProductHoverImageUrl = `${baseUrl}${cookieDescriptionStringArray[8].trim()}`;
          hoverSrcSet = window.Branch.functions.returnSrcSet(cookieProductHoverImageUrl);
        }

       if(styling == 'homepage'){
        let tempSrcSet = srcSet
        srcSet = hoverSrcSet;
        hoverSrcSet = tempSrcSet;
       } 

      if(cookieDescriptionStringArray[11] == 'true'){
        let originalImg = cloneDiv.querySelector('.product-image-container img');
        if(styling == 'homepage'){
          originalImg = cloneDiv.querySelector('.product-image-hover__image')
        }
        let product1Url =  `${baseUrl}${cookieDescriptionStringArray[12].trim()}`;
        let product2Url =  `${baseUrl}${cookieDescriptionStringArray[13].trim()}`;
        let product1SrcSet = window.Branch.functions.returnSrcSet(product1Url);
        let product2SrcSet = window.Branch.functions.returnSrcSet(product2Url);

        originalImg.setAttribute('srcset', product1SrcSet);
        originalImg.classList = 'pre-set-bundle-image__product-overlay';
        // console.log('preset!!');
        let clonedImg = originalImg.cloneNode(true);
        clonedImg.setAttribute('srcset', product2SrcSet);
        originalImg.parentNode.insertBefore(clonedImg, originalImg.nextSibling);
        originalImg.parentNode.classList += ' pre-set-bundle-image-container'
      } else {
        cloneDiv.querySelector('.product-image-container img').setAttribute('srcset', srcSet);
      }
      if(cookieDescriptionStringArray[11] == 'true' && styling == 'homepage'){
        cloneDiv.querySelector('.product-image-container img').setAttribute('srcset', srcSet)
      } else {
      cloneDiv.querySelectorAll('.product-tile__image-container .product-image-hover img').forEach((hoverImage) => {
        hoverImage.setAttribute('srcset', hoverSrcSet);
      })
      }
    }

    const updatePrice = function(cloneDiv, cookieDescriptionStringArray){
      let cookieProductPrice = cookieDescriptionStringArray[2].trim();
      let cookieProductPriceVaries = cookieDescriptionStringArray[3].trim();
      let cookieOriginalProductPrice = cookieDescriptionStringArray[10] ? cookieDescriptionStringArray[10].trim() : cookieProductPrice;


      if(cloneDiv.querySelector('.product-tile__info-container .from')){
        cloneDiv.querySelector('.product-tile__info-container .from').remove();
      }

      const codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(cookieProductPrice, cookieOriginalProductPrice, 0, '', cookieDescriptionStringArray[0].trim());
      cookieProductPrice = codeDiscountData.currentPrice

      
      let priceHtml = `${Shopify.formatMoney((Math.ceil(cookieProductPrice/100)*100), Simplistic.formatMoney).replace('.00', '').replace(' ','')}`;
      let originalPriceHtml = cookieOriginalProductPrice == "" || cookieOriginalProductPrice == "0" ? null : `${Shopify.formatMoney((Math.ceil(cookieOriginalProductPrice/100)*100), Simplistic.formatMoney).replace('.00', '').replace(' ','')}`;
      if(cookieProductPriceVaries == "t"){
        priceHtml = `${priceHtml}+`
      }

      cloneDiv.querySelector('.price .deal span[data-price="deal"]').innerHTML = priceHtml;
      if(originalPriceHtml != null && cookieProductPrice < cookieOriginalProductPrice){
        cloneDiv.querySelector('.price .retail span[data-price="retail"]').innerHTML = originalPriceHtml;
        cloneDiv.querySelector('.price .retail').setAttribute('data-visible', "true")
      } else {
        cloneDiv.querySelector('.price .retail span[data-price="retail"]').innerHTML = '';
        cloneDiv.querySelector('.price .retail').setAttribute('data-visible', "false")
      }
    }

    const updateSalesText = function(cloneDiv, cookieDescriptionStringArray, parent){
      let productStillDiscounted = false;
      let cookieProductSaleText = cookieDescriptionStringArray[6].trim().replaceAll('*', ' ');
      let discountIndex;
      if(cookieProductSaleText.includes('#') == false){
        productStillDiscounted = true;
      } else {
        discountIndex = parseInt(cookieProductSaleText.split('#')[1])
      }
      if(discountIndex > 0){
        let productHandleData = JSON.parse(document.querySelector(`#${parent.getAttribute('id')} #discount-handles-object`).innerText);
        let handles = productHandleData[`discount_code_${discountIndex}_product_handles`];
        if(handles){
          let handlesArray = handles.replaceAll(' ', '').split(',');
          handlesArray.forEach((handle) => {
            if(handle == cookieDescriptionStringArray[0].trim()){
              productStillDiscounted = true;
            }
          })
        }
      }

      if(productStillDiscounted == false) {
        let cookieOriginalProductPrice = cookieDescriptionStringArray[10].trim();
        if(cookieOriginalProductPrice != "" || cookieOriginalProductPrice != "0"){
          cookieDescriptionStringArray[2] = cookieDescriptionStringArray[10];
          cookieDescriptionStringArray[10] = "0";
        }
      }

      let promoProduct = false
      let promoHandles = document.querySelector(`#${parent.getAttribute('id')} #related-products-promo-handles`) ? JSON.parse(document.querySelector(`#${parent.getAttribute('id')} #related-products-promo-handles`).innerText) : undefined;
      if(promoHandles && promoHandles.handles && promoHandles.handles.length > 0){
        promoHandles.handles.forEach((promoHandle) => {
          if(promoHandle == cookieDescriptionStringArray[0].trim()){
            promoProduct = true; 
          }
        })
      }

      if(cloneDiv.querySelector('.sale')){
        cloneDiv.querySelector('.sale').remove();
      }

      let codeDiscountMessage = window.Branch.functions.returnSalesTagText(cookieDescriptionStringArray[0].trim(), 'fromHandle', {});
      if(cookieDescriptionStringArray[11] == 'true'){
        let cookieProductPrice = cookieDescriptionStringArray[2].trim();
        let cookieOriginalProductPrice = cookieDescriptionStringArray[10] ? cookieDescriptionStringArray[10].trim() : cookieProductPrice;
        let discountPercentage = Math.round(
          ((cookieOriginalProductPrice - cookieProductPrice) / cookieOriginalProductPrice) * 100
        );
        
        codeDiscountMessage = `Save ${discountPercentage}%`;
      }

      let displaySwatch = cookieProductSaleText !== '' && cookieProductSaleText !== 'n' && productStillDiscounted == true ? true : codeDiscountMessage != "" ? true : false;

      if(displaySwatch){
        let salesSwatchHtml = `<div data-display="true" ${promoProduct == true ? 'promo-style="true" promo-style-on-hover="true"': ''} data-sale-text="${cookieProductSaleText}" class="sale">${codeDiscountMessage != "" ? codeDiscountMessage : cookieProductSaleText.split('#')[0]}</div>`
        cloneDiv.querySelector('.product-image').insertAdjacentHTML('beforeend', salesSwatchHtml);
      }
    }

    const updateTileData = function(cloneDiv, cookieDescriptionStringArray, cookieProductHandle){
      // console.log('cookieDescriptionStringArray', cookieDescriptionStringArray)
      let cookieProductUrl = cookieDescriptionStringArray[4].trim();
      let cookieProductTitle = cookieDescriptionStringArray[5].trim().replaceAll('*', ' ');
      let cookieVariantTitle = cookieDescriptionStringArray[7].trim().replaceAll('*', ' ');
      let cookieColorCombos = cookieDescriptionStringArray[9].trim().replaceAll('*', ' ');

      cloneDiv.querySelector('a').setAttribute('href',`/products/${cookieProductHandle}`);
      cloneDiv.querySelector('.title').innerHTML = `${cookieProductTitle}`;
      cloneDiv.querySelector('.product-tile__image-container .product-image').setAttribute('data-title', cookieProductTitle);
      cloneDiv.querySelector('.product-tile__image-container .product-image').setAttribute('data-variant', cookieVariantTitle);
      cloneDiv.querySelector('.product-tile__image-container .product-image').removeAttribute('data-variant-id');
      cloneDiv.setAttribute('data-id', Math.floor(1000 + Math.random() * 9000));


      if(cloneDiv.querySelector('.product-available-colors')){
        cloneDiv.querySelector('.product-available-colors').innerHTML = `${cookieColorCombos}`;
      }
    }

    const insertNewSlide = function(cookieDescriptionStringArray, cookieProductHandle, newProductHandles, slidesReplaced, productAlreadyInList, relatedProductsSection, parent, styling) {
      let slides = document.querySelectorAll(`#${parent.getAttribute('id')} .related-products__product-carousel .product-tile`);
    
      if (slides.length === 0) return;
    
      const firstSlide = slides[slidesReplaced - 1];
      const cloneDiv = firstSlide.cloneNode(true);
    
      let lastSlide = slides[slides.length - 1];
    
      if (productAlreadyInList) {
        let existingSlide = document.querySelector(`#${parent.getAttribute('id')} .related-products__product-carousel .product-tile a[href="/products/${cookieProductHandle}"]`);
        if (existingSlide) {
          lastSlide = existingSlide.closest('.product-tile');
        }
      }
    
      updateImageSrcSet(cloneDiv, cookieDescriptionStringArray, styling);
      updateSalesText(cloneDiv, cookieDescriptionStringArray, parent);
      updatePrice(cloneDiv, cookieDescriptionStringArray);
      updateTileData(cloneDiv, cookieDescriptionStringArray, cookieProductHandle);
    
      document.querySelector(`#${parent.getAttribute('id')} .related-products__product-carousel`).insertBefore(cloneDiv, firstSlide);
      lastSlide.remove();
      newProductHandles.push(cookieProductHandle);
    }

    const selectQualifyingRecentlyViewedProducts = function(cookieArray, relatedProductsSection, parent, styling){
      let existingHandles = document.querySelector(`#${parent.getAttribute('id')} .related-products.page-container`).getAttribute('data-product-handles').split(',');
      let currentProductHandle = document.querySelector(`#${parent.getAttribute('id')} .related-products.page-container`).getAttribute('data-current-product-handle');
      let newProductHandles = [];
      let slidesReplaced = 0;

      cookieArray.forEach((cookieDescriptionString) => {
        if(cookieDescriptionString != "" ){
          let cookieDescriptionStringArray = cookieDescriptionString.split('@@');
          let cookieProductHandle = cookieDescriptionStringArray[0].trim();
          if(!newProductHandles.includes(cookieProductHandle) && cookieProductHandle !== currentProductHandle){
            slidesReplaced = slidesReplaced + 1;
            if(slidesReplaced < 4){
              insertNewSlide(cookieDescriptionStringArray, cookieProductHandle, newProductHandles, slidesReplaced, existingHandles.includes(cookieProductHandle), relatedProductsSection, parent, styling); 
            }
          } 
        }
      })
    }

    const updateSliderAriaLabels = function(relatedProductsSection, parent){
      let updatedSlides = document.querySelectorAll(`#${parent.getAttribute('id')} .related-products__product-carousel .product-tile`);
      let cascadeIndex = 0;
      if(updatedSlides){
        cascadeIndex = parseInt(updatedSlides[0].getAttribute('data-cascade-order'));
      }
      
          updatedSlides.forEach((updatedSlide, index) => {
          updatedSlide.setAttribute('aria-label', `${index + 1} / ${updatedSlides.length}`);
          if(updatedSlides[updatedSlides.length - 1].getAttribute('data-animated') != 'true'){
            updatedSlide.setAttribute('data-cascade-order', `${cascadeIndex}`);

            const width = window.innerWidth;

            if (
                (width < 840 && index < 1) ||
                (width < 1024 && index < 2) ||
                (width >= 1024 && index < 3)
            ) {
                cascadeIndex++;
            }
          }
      });
      

    }

    const retrieveRecentlyViewProducts = function(relatedProductsSection, parent, styling){
      if(document.cookie.split("; ").find((row) => row.startsWith("shopify_recently_viewed_data="))){
        const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith("shopify_recently_viewed_data="))
        ?.split("=")[1];

        let cookieString = decodeURIComponent(cookieValue).trim();
        let cookieArray = cookieString.split('|||'); 

        if(cookieArray.length > 0){
          selectQualifyingRecentlyViewedProducts(cookieArray, relatedProductsSection, parent, styling);
          updateSliderAriaLabels(relatedProductsSection, parent);
        }
      }
    }

    const updatePricingForCart = function(relatedProductsSection){
      relatedProductsSection.querySelectorAll('.product-tile .price').forEach((price) => {
        let handle = price.getAttribute('data-product-handle');
        let priceData = document.querySelector(`.per-variant-pricing[data-product-handle="${handle}"]`) ? JSON.parse(document.querySelector(`.per-variant-pricing[data-product-handle="${handle}"]`).innerText) : {};
        let productTile = price.closest('.product-tile');
        let variantId = parseInt(productTile.getAttribute('data-variant-id'))
        let tileType = 'regular';
        window.Branch.collection.updateDisabledSwatchedPrice(productTile, priceData, tileType, handle, variantId);
      }) 
    }

    const initToolTips = function(relatedProductsSection) {
      relatedProductsSection.querySelectorAll('.related-products__ux-toggle-container').forEach(wrapper => {
        const button = wrapper.querySelector('.related-products__ux-toggle');
        const tooltip = wrapper.querySelector('.related-products__ux-toggle-tooltip');
        if (window.Branch.functions.isTouchDevice()) {
          let isVisible = false;
      
          button.addEventListener('click', (e) => {
            e.stopPropagation();
            isVisible = !isVisible;
            tooltip.setAttribute('data-visible', isVisible);
          });
      
          tooltip.addEventListener('click', (e) => {
            e.stopPropagation();
          });
      
          document.body.addEventListener('click', () => {
            isVisible = false;
            tooltip.setAttribute('data-visible', false);
          });
        } else {
          let hideTimeout;
          wrapper.addEventListener('mouseenter', () => {
            clearTimeout(hideTimeout);
            tooltip.setAttribute('data-visible', true);
          });
          
          wrapper.addEventListener('mouseleave', () => {
            hideTimeout = setTimeout(() => {
              tooltip.setAttribute('data-visible', false);
            }, 250);
          });
          
          tooltip.addEventListener('mouseenter', () => {
            clearTimeout(hideTimeout);
          });
          
          tooltip.addEventListener('mouseleave', () => {
            tooltip.setAttribute('data-visible', true);
          });

        }
      
        wrapper.querySelector('.related-products__ux-toggle-tooltip-link').addEventListener('click', (e) => {
          e.preventDefault();
          const targetToggle = document.querySelector('.toggle-header-title-bar-container__toggle-dtc-element');

          window.scrollTo({ top: 0, behavior: 'smooth' });

          let lastPosition = window.scrollY;
          let checkCount = 0;
          const maxChecks = 30;

          const waitForScrollEnd = () => {
            const currentPosition = window.scrollY;

            if (currentPosition === 0 || checkCount > maxChecks) {
              if (targetToggle) {
                setTimeout(function(){
                  targetToggle.click();
                }, 1500)
              }
              return;
            }

            checkCount++;
            setTimeout(waitForScrollEnd, 100);
          };

          waitForScrollEnd();
          
        });
      });
      
    }

   
    const initQuizCheckoutATC = function(relatedProductsSection){
      relatedProductsSection.addEventListener('click', function(event) {
        const target = event.target.closest('.related-products__cta');
        console.log()
        if (!target) return;
        const isQuizCheckout = target.getAttribute('data-quiz-checkout') === 'true';
      
        if (isQuizCheckout) {
          event.preventDefault();
          const ids = target.getAttribute('data-quiz-checkout-ids').split(',');
          if(ids.length > 0){
            $('#loading-overlay').show();
          
          console.log('ids', ids);
          const items = ids.map(id => ({
            id,
            quantity: 1,
            properties: {
              _ship_date: document.querySelector(`.msbd-message__input[data-variant-id="${id}"]`).value
            }
          }));
        
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
          })
          .then(response => {
            if (!response.ok) {
              throw new Error('Failed to add to cart');
            }
            return response.json();
          })
          .then(data => {
            console.log('Added items:', data);
            $('#loading-overlay').hide();
            window.Branch.cart.updateCartDesc(true);
            target.innerHTML = 'Checkout';
            target.removeAttribute('data-quiz-checkout');
            target.setAttribute('href', '/checkout');
          })
          .catch(error => {
            console.error('Error adding to cart:', error);
          });
        }
      }
      });
      
    }

    const initRelatedProducts = function(relatedProductsSection, parent){
      console.log('initRelatedProducts')
      initRelatedProductsSlider(relatedProductsSection, parent); 
      if(relatedProductsSection.getAttribute('data-type') == "cart" || relatedProductsSection.getAttribute('data-type') == "quiz"){
        updatePricingForCart(relatedProductsSection)
      }

      if(relatedProductsSection.getAttribute('data-type') == "quiz"){
        initQuizCheckoutATC(relatedProductsSection);
      }

      initToolTips(relatedProductsSection);

      if(relatedProductsSection.getAttribute('data-recently-viewed') == "true" && relatedProductsSection.getAttribute('data-type') != "cart" && relatedProductsSection.getAttribute('data-type') != "quiz"){
        let styling = relatedProductsSection.getAttribute('data-styling');
        retrieveRecentlyViewProducts(relatedProductsSection, parent, styling);
        relatedProductsSection.setAttribute('data-type', 'browsed');
        relatedProductsSection.querySelectorAll('.related-products__title-subtitle-container:not([data-type="browsed"]), .related-products__cta:not([data-type="browsed"])').forEach((titleSubtitleContainer) => {titleSubtitleContainer.setAttribute('aria-hidden', true)})
        relatedProductsSection.querySelectorAll('.related-products__title-subtitle-container[data-type="browsed"], .related-products__cta:not([data-type="browsed"])').forEach((titleSubtitleContainer) => {titleSubtitleContainer.setAttribute('aria-hidden', false)})
      }
    }

    window.Branch.relatedProducts.relatedProductsInitOnLoad = function(){
      let relatedProductsSections = document.querySelectorAll('.related-products:not([data-initialized="true"])');
      relatedProductsSections.forEach((relatedProductsSection) => {
          let parent = relatedProductsSection.closest('.shopify-section');
          relatedProductsSection.setAttribute('data-initialized', true);
          initRelatedProducts(relatedProductsSection, parent);
      })  
  }

  if (document.readyState === "complete") {
      window.Branch.relatedProducts.relatedProductsInitOnLoad(); 
  } else {
      window.addEventListener("load", window.Branch.relatedProducts.relatedProductsInitOnLoad);
  }
});
